import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { UserRole } from '../user-role';
import { User } from '../user';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgIf } from '@angular/common';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DarkModeService } from '@app-shared/services/dark-mode.service';

@Component({
  selector: 'app-mobile-navbar',
  templateUrl: './mobile-navbar.component.html',
  styleUrls: ['./mobile-navbar.component.css'],
  imports: [NgbCollapse, NgIf, RouterLink, RouterLinkActive, FontAwesomeModule]
})
export class MobileNavbarComponent implements OnInit {

  // Properties
  isNavbarCollapsed: boolean = true;
  public hasAccess: boolean = true;
  loginDetails: User;
  isDarkModeEnabled: boolean = false;

  // font awesome
  faSun = faSun;
  faMoon = faMoon;

  constructor(private authService: AuthService,
    private darkModeService: DarkModeService
  ) {
    this.darkModeService.darkModeChanged$.subscribe((isDarkModeEnabled) => {
      this.isDarkModeEnabled = isDarkModeEnabled;
    });
  }

  ngOnInit(): void {
    this.loginDetails = JSON.parse(localStorage.getItem('login'));
    let login = JSON.parse(localStorage.getItem("login"));

    if ((login?.subscription.price === 29 || !login?.isWithCardOnFile) && (login?.role === "SUPER" || login?.role === "FRANCHISE_OWNER") || login.monthDelinquent > 1) {
      this.hasAccess = false;
    }
  }

  // Is Authorized
  isAuthorized(): boolean {
    return this.authService.isAuthorized(UserRole.FRANCHISEE);
  }

  // Toggle
  toggle(): void {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }

  // Logout
  logout(): void {
    this.authService.logout();
  }

  // Toggle Dark Mode
  toggleDarkMode(): void {
    this.darkModeService.toggleDarkMode();
  }
}
